












import { Component, Prop, Vue } from 'vue-property-decorator';
import playSound from '../../utils/sounds/index';

@Component({
  components: {},
})
export default class Btn extends Vue {
  @Prop({ default: '' }) private title!: string;

  @Prop({ default: '' }) private method!: () => void;

  playButtonSound = (): void => {
    playSound('button');
  };
}
